import { render, staticRenderFns } from "./AddFunctionToMember.vue?vue&type=template&id=71cebb8f"
import script from "./AddFunctionToMember.vue?vue&type=script&lang=js"
export * from "./AddFunctionToMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports